// ** MUI Imports
import { PaletteMode } from '@mui/material'

// ** Types
type ContentWidth = 'full' | 'boxed'
type ThemeConfig = {
  mode: PaletteMode
  templateName: string
  logo: string
  routingLoader: boolean
  disableRipple: boolean
  navigationSize: number
  menuTextTruncate: boolean
  contentWidth: ContentWidth
  responsiveFontSizes: boolean
}

const themeConfig: ThemeConfig = {
  // ** Layout Configs
  templateName: 'Villa Mina' /* App Name */,
  logo: '/images/vilaMina/logo.png' /* App Logo */,
  mode: 'light' /* light | dark */,
  contentWidth: 'boxed' /* full | boxed */,

  // ** Routing Configs
  routingLoader: true /* true | false */,

  // ** Navigation (Menu) Configs
  menuTextTruncate: true /* true | false */,
  navigationSize: 260 /* Number in PX(Pixels) /*! Note: This is for Vertical navigation menu only */,

  // ** Other Configs
  responsiveFontSizes: true /* true | false */,
  disableRipple: false /* true | false */
}

export default themeConfig
